import { getTableURL } from '@utils/getTableURL';
import { camelizeKeys } from 'humps';
import { isNil } from 'ramda';

import { NAVIGATION_METHODS } from '@ezugi/constants';
import { navigate, isUrl, isPopup } from '@ezugi/utils';

import { sendHomeMessage } from './postMessage';

const doNavigation = ({
  method,
  url,
  width,
  height,
  outerLink,
  queryString,
}) => {
  const _outerLink = isNil(outerLink)
    ? method === NAVIGATION_METHODS.REPLACE
    : outerLink;
  navigate(method, url, {
    width,
    height,
    outerLink: _outerLink,
    queryString,
  });
};

const doHomeNavigation = ({
  homeMethod: method,
  homeUrl: url,
  outerLink,
  homeUseEzugiLobby = false,
  identifier,
}) => {
  doNavigation({
    method,
    url,
    outerLink,
    queryString: new URLSearchParams({
      identifier,
    }).toString(),
  });
  if (isPopup() && !homeUseEzugiLobby) window.close();
};

export const goHome = (home, outerLink, authParams, identifier) => new Promise((resolve, reject) => {
  const { postMessage, homeUrl } = authParams;
  home = camelizeKeys(home);
  const { allowHomeUrlAuthParam, homeUseEzugiLobby } = home;

  try {
    if (postMessage === '1' || home.homeMethod === NAVIGATION_METHODS.POST) {
      sendHomeMessage();
    } else {
      const homeConfig = {
        ...home,
        ...(allowHomeUrlAuthParam
            && homeUrl
            && isUrl(homeUrl) && { homeUrl }),
        outerLink,
        homeUseEzugiLobby,
        identifier,
      };
      doHomeNavigation(homeConfig);
    }
    resolve({ ok: true, method: home.homeMethod });
  } catch (e) {
    reject(e);
  }
});

export const openCashier = (cashierConfig, cashierUrl) => {
  doNavigation({
    method: cashierConfig.cashier_method,
    url:
      typeof cashierUrl !== 'undefined' && isUrl(cashierUrl)
        ? cashierUrl
        : cashierConfig.cashier_url,
    width: cashierConfig.cashier_popupWidth,
    height: cashierConfig.popupHeight,
    outerLink: cashierConfig.cashier_method === NAVIGATION_METHODS.REPLACE,
  });
};

export const openTable = ({ method, ...args }) => {
  const url = getTableURL({ method, ...args });

  doNavigation({ method, url, outerLink: true, useSamePopup: true });
};

export const getGameNameById = (gameTypes, gameId) => gameTypes[gameId]?.redirect_to;

export const isReferrerSameHostname = () => document.referrer.split('/')[2] === window.location.hostname;
